import * as React from 'react';
import { useSelector } from 'react-redux';
import { InterestRate } from '../../components/InterestRate';
import { selectBanksRates } from '../../selectors/mortgageBanksData';

export function InterestRateContainer() {
  const rates = useSelector(selectBanksRates);

  return <InterestRate rates={rates} />;
}
